import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Pica je grozna",
  "description": "",
  "published": "2007-02-26T00:00:00.000Z",
  "redirect_from": ["/blog/pica-je-grozna/swizec/282"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`In takole te lahko pica pusti zaznamovanega in prestrasenega za celo zivljenje.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      